<style scoped>
    .page-per{
        font-weight: bolder;
        font-size: 16px;
    }
</style>
<template>
       <div class="page-per">全{{ total }}件｜{{ offset }}～{{ limit }}件表示</div>
</template>
<script>
    export default {
        data() {
            return {
                offset: 0,
                limit: 0,
            }
        },
        props: {
            total: {
                type: Number,
                default: "0"
            },
            items_per_page: {
                type: Number,
                default: "0"
            },
            page: {
                type: Number,
                default: "0"
            },
        },
        watch: {
            page(new_page) {
                this.setOffset(new_page);
                this.setLimit(new_page);
            }
        },
        beforeUpdate() {
            this.setOffset(this.page);
            this.setLimit(this.page);
        },
        methods: {
            setOffset(page) {
                if(page > 1){
                    this.offset = (page - 1) * this.items_per_page + 1;
                }else if(this.total == 0){
                    this.offset = 0;
                }else{
                    this.offset = 1;
                }
            },
            setLimit(page) {
                if(page * this.items_per_page > this.total){
                    this.limit = this.total;
                }else{
                    this.limit = this.items_per_page * page;
                }
            },
        },
    }
</script>